(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rotating-text"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  var $item = $(".rotatingtextitem");
  $item.hide().eq(0).show();
  var nTotal = $item.length;
  var nPos = 0;
  setInterval(RotateLinks, 750);

  function RotateLinks() {
    $item.eq(nPos).fadeOut(0, function() {
      nPos++;
      if (nPos == nTotal) {
        nPos = 0;
      }
      $item.eq(nPos).fadeIn(0)
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
